"use strict";
import React from "react";
import { DropdownTheme } from "./DropdownTheme";
const DropdownContext = React.createContext({
  theme: DropdownTheme.Light
});
export { DropdownContext };
